import backend from './backend';
import {toNumericId} from "@/api/utils";


export default {
    update(productId, inventoryItemId, quantity, changeFromQuantity, locationId){
        return backend.put(
            `/products/${toNumericId(productId)}/inventory`,
            {
                name: 'available',
                reason: 'correction',
                quantities: [
                    { quantity, changeFromQuantity, inventoryItemId, locationId }
                ]
            }
        )
    }
}